/**
 * Import types
 */

export const ImportTypes = {
  IMPPRODUCTS: 'impproducts',
  IMPPRODUCTSTEMPLATEMEDIA: 'impproductstemplatemedia',
  IMPDECODED: 'impdecoded',
  IMPDECODEDMEDIA: 'impdecodedmedia',
  IMPPROMOTIONSMEDIA: 'imppromotionsmedia',
  IMPUSERS: 'impusers',
  IMPDEVICES: 'impdevices',
  IMPCUSTOMERS: 'impcustomers'
};

/**
 * Permissions associated with import types
 */
export const PermissionsImportType = {
  impproducts: 'PRD_BO_IMPORT_PRODUCT_IMAGES',
  impproductstemplatemedia: 'PRD_BO_IMPORT_TEMPLATE_IMAGES',
  impdecoded: 'STR_BO_IMPORT_DECODED_DATA',
  impdecodedmedia: 'STR_BO_IMPORT_DECODED_IMAGES',
  imppromotionsmedia: 'SLC_BO_IMPORT_SALESCONDITION_IMAGES',
  impusers: 'USR_BO_IMPORT_USER_LIST',
  impdevices: 'USR_BO_IMPORT_DEVICE_LIST',
  impcustomers: 'CUS_BO_IMPORT_CUSTOMER_IMAGES'
};

export const ImportTitles = {
  impproducts: 'product.import.title',
  impproductstemplatemedia: 'templates.import.templatesTitle',
  impdecoded: 'decoded.value.importDataTitle',
  impdecodedmedia: 'decoded.value.importImagesTitle',
  imppromotionsmedia: 'core.import.type.promotions.multimedia',
  impusers: 'core.import.type.users',
  impdevices: 'core.import.type.devices',
  impcustomers: 'customer.import.title'
};
